// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"motion-sidebar_sidebar__3EQEW","separator":"motion-sidebar_separator___twUO"};